"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetPeriodEnum = void 0;
var StatsWidgetPeriodEnum;
(function (StatsWidgetPeriodEnum) {
    StatsWidgetPeriodEnum["LIVE_TODAY"] = "LIVE_TODAY";
    StatsWidgetPeriodEnum["TODAY"] = "TODAY";
    StatsWidgetPeriodEnum["LAST_24_HOURS"] = "LAST_24_HOURS";
    StatsWidgetPeriodEnum["YESTERDAY"] = "YESTERDAY";
    StatsWidgetPeriodEnum["THIS_WEEK"] = "THIS_WEEK";
    StatsWidgetPeriodEnum["THIS_WEEK_SUN"] = "THIS_WEEK_SUN";
    StatsWidgetPeriodEnum["THIS_WEEK_EXCEPT_TODAY"] = "THIS_WEEK_EXCEPT_TODAY";
    StatsWidgetPeriodEnum["THIS_WEEK_SUN_EXCEPT_TODAY"] = "THIS_WEEK_SUN_EXCEPT_TODAY";
    StatsWidgetPeriodEnum["LAST_WEEK"] = "LAST_WEEK";
    StatsWidgetPeriodEnum["LAST_7_DAYS"] = "LAST_7_DAYS";
    StatsWidgetPeriodEnum["THIS_MONTH"] = "THIS_MONTH";
    StatsWidgetPeriodEnum["THIS_MONTH_EXCEPT_TODAY"] = "THIS_MONTH_EXCEPT_TODAY";
    StatsWidgetPeriodEnum["LAST_30_DAYS"] = "LAST_30_DAYS";
    StatsWidgetPeriodEnum["LAST_MONTH"] = "LAST_MONTH";
    StatsWidgetPeriodEnum["CUSTOM"] = "CUSTOM";
})(StatsWidgetPeriodEnum = exports.StatsWidgetPeriodEnum || (exports.StatsWidgetPeriodEnum = {}));
